import type {Vector2Like} from "@cm/math"
import {
    TEXTURE_TILES_MAX_IDS,
    TEXTURE_TILES_MAX_MIP_LEVELS,
    TEXTURE_TILES_MAX_TILES_X,
    TEXTURE_TILES_MAX_TILES_Y,
} from "#three-texture-streaming/texture-tile-constants"

export type TextureTileId = number

// textureTileId layout: [ threeTiledTextureId: 12 bits | mipLevel: 4 bits | tileY: 8 bits | tileX: 8 bits ]

export const encodeTextureTileId = (tiledTextureId: number, mipLevel: number, tileIndex: Vector2Like): TextureTileId => {
    if (tiledTextureId < 1 || tiledTextureId >= TEXTURE_TILES_MAX_IDS) {
        throw new Error(`encodeTextureTileId: tiledTextureId out of range: ${tiledTextureId}`)
    }
    if (mipLevel < 0 || mipLevel >= TEXTURE_TILES_MAX_MIP_LEVELS) {
        throw new Error(`encodeTextureTileId: mipLevel out of range: ${mipLevel}`)
    }
    if (tileIndex.x < 0 || tileIndex.x >= TEXTURE_TILES_MAX_TILES_X) {
        throw new Error(`encodeTextureTileId: tileIndex.x out of range: ${tileIndex.x}`)
    }
    if (tileIndex.y < 0 || tileIndex.y >= TEXTURE_TILES_MAX_TILES_Y) {
        throw new Error(`encodeTextureTileId: tileIndex.y out of range: ${tileIndex.y}`)
    }
    return (tiledTextureId << 20) | (mipLevel << 16) | (tileIndex.y << 8) | tileIndex.x
}

export const decodeTextureTileId = (textureTileId: TextureTileId): {tiledTextureId: number; mipLevel: number; tileIndex: Vector2Like} => {
    const tiledTextureId = (textureTileId >> 20) & 0xfff
    const mipLevel = (textureTileId >> 16) & 0xf
    const tileY = (textureTileId >> 8) & 0xff
    const tileX = textureTileId & 0xff
    return {
        tiledTextureId,
        mipLevel,
        tileIndex: {x: tileX, y: tileY},
    }
}
